<template>
    <div
        id="todo-app"
        class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
    >
        <vue-headful :title="$t('list-registered-students')" />

        <vs-sidebar
            class="items-no-padding"
            parent="#todo-app"
            :click-not-close="clickNotClose"
            :hidden-background="clickNotClose"
            v-model="isSidebarActive"
        >
            <!-- ФИЛЬТРЫ -->
            <component
                :is="'VuePerfectScrollbar'"
                ref="filterScroll"
                class="custom_scroll"
                :settings="settings"
                :key="$vs.rtl"
            >
                <div class="todo__filters-container">
                    <div v-if="!loading">
                        <div class="px-6 py-4">
                            <!-- Кнопка сбросить фильтр -->
                            <div
                                class="flex cursor-pointer"
                                @click="clearAllSelects"
                            >
                                <feather-icon
                                    icon="FilterIcon"
                                    svgClasses="h-6 w-6"
                                ></feather-icon>
                                <span class="text-lg ml-3">{{
                                    $t("show_all")
                                }}</span>
                            </div>
                        </div>

                        <vs-divider class="mb-0 mt-0"></vs-divider>
                        <!-- Список селектов (Рендер происходит по структуре) -->
                        <MySelect
                            v-for="select in listSelects"
                            :data="select"
                            :key="select.nameI18nAndQueryParam"
                        />

                        <div class="px-6 py-4 lg:hidden">
                            <vs-button @click="toggleSidebar()" class="w-full">{{$t('apply')}}</vs-button>
                        </div>
                    </div>
                </div>
            </component>
        </vs-sidebar>
        <div
            :class="{ 'sidebar-spacer': clickNotClose }"
            class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content"
        >
            <!-- sidebar mobile -->
            <div class="flex border d-theme-dark-bg items-center">
                <feather-icon
                    class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer"
                    icon="MenuIcon"
                    @click.stop="toggleSidebar(true)"
                />
            </div>
            <!-- список дисциплин -->

            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                :key="$vs.rtl"
                @ps-y-reach-end="getPagination"
            >
                <ul v-if="disList.length">
                    <li
                        class="todo_todo-item cursor-pointer"
                        @click="openStudent(item)"
                        v-for="(item, index) in disList"
                        :key="`d_${index}`"
                        :style="[{ transitionDelay: index * 0.1 + 's' }]"
                    >
                        <ListItem :item="item" />
                    </li>
                </ul>

                <div class="mt-4 ml-5 mr-5" v-else>
                    <vs-alert active="true">
                        {{ $t("no_data_text") }}
                    </vs-alert>
                </div>
            </component>
        </div>
    </div>
</template>

<script>
import ListItem from "./ListItem.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    data() {
        return {
            isSidebarActive: true,
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            disList: [],
            load: false,
            page: 0,
            check: false,
            nextPage: 1,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6,
            },

            listSelects: [
                {
                    nameI18nAndQueryParam: "study_year",
                    endpoint: "common/study_years/",
                    dependents: [
                        "registration_period",
                        "faculty",
                        "cathedra",
                        "speciality",
                        "educational_program",
                        "course",
                        "group",
                    ],
                },
                {
                    nameI18nAndQueryParam: "reg_period",
                    endpoint: "common/reg_periods/",
                    dependents: [
                        "study_year",
                        "faculty",
                        "cathedra",
                        "speciality",
                        "educational_program",
                        "course",
                        "group",
                    ],
                },

                {
                    nameI18nAndQueryParam: "faculty",
                    endpoint: "advisors/faculties/",
                    params: ["study_year"],
                    dependents: [
                        "cathedra",
                        "speciality",
                        "educational_program",
                        "course",
                        "group",
                    ],
                },

                {
                    nameI18nAndQueryParam: "acad_period",
                    endpoint: "advisors/acad_periods/",
                    dependents: [
                        "study_year",
                        "faculty",
                        "cathedra",
                        "speciality",
                        "educational_program",
                        "course",
                        "group",
                    ],
                    params: ["study_year", "reg_period"],
                },
                {
                    nameI18nAndQueryParam: "edu_prog",
                    endpoint: "advisors/edu_programs/",
                    params: ["study_year", "faculty", "cathedra"],
                    dependents: ["course", "group"],
                },
                {
                    nameI18nAndQueryParam: "course",
                    endpoint: "common/courses/",
                    dependents: ["group"],
                },
                {
                    nameI18nAndQueryParam: "group",
                    endpoint: "advisors/groups/",
                    params: [
                        "study_year",
                        "faculty",
                        "cathedra",
                        "speciality",
                        "educational_program",
                        "course",
                    ],
                },
                {
                    nameI18nAndQueryParam: "speciality",
                    endpoint: "advisors/speciality/",
                    params: [
                        "study_year",
                        "faculty",
                        "cathedra",
                        "educational_program",
                        "course",
                    ],
                },
            ],
        };
    },
    components: {
        VuePerfectScrollbar,
        ListItem,
        MySelect: () => import("./Multiselect"),
    },
    watch: {
        windowWidth() {
            this.setSidebarWidth();
        },
        "$route.query"() {
            // Проверка заполнено ли достаточно селектов, чтобы получить список заявок от студентов
            this.checkSelectsDataForRequest();
        },
    },
    computed: {
        windowWidth() {
            return this.$store.state.windowWidth;
        },
        ...mapGetters({
            getDataStore: "lrs/getData",
        }),
    },

    created() {
        if (this.getDataStore.length !== 0) {
            this.disList = this.getDataStore;
            this.check = true;
        }
        this.setSidebarWidth()
    },

    methods: {
        ...mapMutations({
            setDataStore: "lrs/SET_DATA",
        }),
        // Открытие страницы список студентов дисциплины
        openStudent(item) {
            this.$router.push({
                name: "list-registered-students/list",
                query: {
                    load_type_id: item.load_type_id,
                    language_id: item.language_id,
                    discipline_id: item.discipline_id,
                    hours: item.hours,
                    acad_period: item.acad_period_uid,
                    acad_period_repr_name: item.acad_period_repr_name,
                    discipline: item.discipline,
                    short_load_type: item.short_load_type,
                },
            });
        },

        clearAllSelects() {
            this.$router.replace({ name: this.$route.name, query: {} });
        },
        checkSelectsDataForRequest() {
            this.check = false;
            // Получаю массив из обязательных полей из структуры
            const listRequired = this.listSelects.filter((obj) => obj.required);
            // Получаю массив из имеющихся заполненных обязательных селектов
            const numberQueryRequired = Object.keys(
                this.$route.query
            ).filter((key) =>
                this.listSelects.some(
                    (obj) => obj.nameI18nAndQueryParam === key && obj.required
                )
            );
            // Сравниваю, что все обязательные селекты заполнены и делаю запрос
            if (numberQueryRequired.length === listRequired.length) {
                this.nextPage = 1;
                this.disList = [];
                this.getPagination();
            }
        },

        // Запрос с бесконечной прокруткой
        async getPaginationDist() {
            this.load = true;
            if (this.nextPage === 1) {
                this.loading = true;
            }
            this.$vs.loading();
            const response = (
                await this.$http.get(
                    `advisors/registration/results/?my=1${
                        this.nextPage ? `&page=${ this.nextPage }` : "&page=1"
                    }`,
                    {
                        params: this.$route.query,
                    }
                )
            ).data;

            if (this.disList.length === 0) {
                this.disList = response.results;
            } else {
                this.disList = this.disList.concat(response.results);
            }

            this.setDataStore(this.disList);

            if (response.next) {
                this.nextPage += 1;
            } else {
                this.nextPage = false;
            }
            this.$vs.loading.close();
            this.loading = false;
            this.load = false;
        },
        // Метод для бесконечной прокрутки
        async getPagination() {
            if (!this.check) {
                if (this.nextPage && !this.load) {
                    await this.getPaginationDist();
                }
            }
        },

        toggleSidebar(value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return;
            this.isSidebarActive = value;
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false;
            } else {
                this.isSidebarActive = this.clickNotClose = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#todo-app::v-deep {
    .vs-sidebar--items {
        overflow-y: auto !important;
    }
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.emc__actions {
    .con-vs-tabs {
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs {
        display: none;
    }
}
.emc_list_tabs {
    .con-ul-tabs {
        display: none;
    }
    .vs-tabs--content {
        padding: 0px;
    }
}
.filters_scroll_area {
    position: relative;
    width: 100%;
    margin: auto;
    &.aside_scroll_teacher {
        height: calc(100% - 67px);
    }
    &:not(.aside_scroll_teacher) {
        height: 100%;
    }
}
.infinite_scroll_wrapper {
    margin: auto;
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    .infinite_alert {
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader {
    padding: 20px 0;
    .con-vs-loading {
        background: transparent;
    }
}
.full-vs-sidebar {
    .mail-sidebar-content {
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
        border-bottom: 1px solid #eee;
    }
}
.todo__filters-container {
    .multiselect__single {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
